import { Component, OnInit } from '@angular/core';
import { Finyearmst, Txncategory } from '../../models/tallyentry-api-model';
import { BookNoSearch } from '../../models/bookno-receipt-model';
import { UtilityService } from '../../services/utility-service';
import { TallyReceiptService } from '../../services/tallyentry-service';
import { Analytics, DashboardModel, DashboardResponseModel } from '../../models/dashboard-model';
import { DatePipe } from '@angular/common';
import { AnalyticsService } from '../../services/analytics-service';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { BookNumReceiptDTO } from '../../models/daybook-model';

@Component({
  selector: 'app-dashboard-ui',
  templateUrl: './dashboard-ui.component.html',
  styleUrls: ['./dashboard-ui.component.css']
})
export class DashboardUIComponent implements OnInit {
  public l_categoryList: Txncategory[] = [];
  public l_financialYearList = [];
  public l_formData: Analytics = new Analytics();
  public l_dashboardData: DashboardResponseModel = new DashboardResponseModel();
  public l_isJsym: boolean = false;
  public l_txnTypeLabel: string = 'Mandal Transactions';

  public minDatePicker: Date;
  public maxDatePicker: Date;  

  constructor(
    public l_UtilityService: UtilityService,
    private l_TallyReceiptService: TallyReceiptService,
    private l_datePipe: DatePipe,
    private l_analyticsService: AnalyticsService
  ) { }

  async ngOnInit(): Promise<void> {
    this.lFN_GetFinancialYear();
    this.lFN_GetCategorySelect();
    // this.l_formData.fromDate = new Date(2024, 3, 1);
    // this.l_formData.toDate = new Date(2025, 2, 31);
    await this.lFN_SetFinancialMinMaxDates();
    this.l_formData.fromDate = this.minDatePicker;
    this.l_formData.toDate = this.maxDatePicker;
    this.lFN_PullDashboardData();
  }

  lFN_GetFinancialYear() {
    let l_finyearResponse = this.l_TallyReceiptService.lFN_GetFinyearmst();
    l_finyearResponse.subscribe({
        next: async (data) => {
          if (data.status == 200) {
            let l_financialYearList: Finyearmst[] = [];
            for await (const l_finyear of JSON.parse(data.body)) {
              l_financialYearList.push(new Finyearmst(l_finyear))
            }
            this.l_financialYearList = l_financialYearList;
            console.log(this.l_financialYearList);

            let l_currentfinyearmstId = this.l_financialYearList.find(l_row => l_row.status === true)?.finyearmstId;
            console.log('l_currentfinyearmstId ===> ', l_currentfinyearmstId);
            this.l_formData.finyearmstId = l_currentfinyearmstId;

            this.l_UtilityService.lFN_HideLoader();
          }
        },
        error: (l_error) => {
          this.l_UtilityService.lFN_ErrorToaster('Unable to fetch Financial Year', 'Failure');
          this.l_UtilityService.lFN_HideLoader();
        },
        complete: () => {
          this.l_UtilityService.lFN_HideLoader();
        }
      });
  }

  lFN_GetFinancialYearText(finyearmstId: number) {
    if (finyearmstId) {
      const year = this.l_financialYearList.find(year => year.finyearmstId === finyearmstId);
      return year ? year.finyear : '';
    }
  }

  async lFN_PullDashboardData() {
    console.log('l_formData === ', this.l_formData);
    let l_fromDateStr = this.l_datePipe.transform(this.l_formData.fromDate, 'yyyy-MM-dd');
    let l_toDateStr = this.l_datePipe.transform(this.l_formData.toDate, 'yyyy-MM-dd');

    this.l_UtilityService.lFN_ShowLoader();
    let l_responseAnalytics = this.l_analyticsService.lFN_PullAnalyticsData(l_fromDateStr, l_toDateStr);
    l_responseAnalytics.subscribe({
      next: async (data) => {
        if (data.status == 200) {
          let l_list: DashboardResponseModel[] = [];
          for await (const [index, element] of JSON.parse(data.body).entries()) {
            console.log('element === ', element);
            l_list.push(element);
          }
          console.log('l_list ===> ', l_list);
          this.l_dashboardData = l_list[0];
          console.log('this.l_dashboardData === ', this.l_dashboardData);
          this.l_UtilityService.lFN_HideLoader();
        }
      },
      error: (l_error) => {
        this.l_UtilityService.lFN_ErrorToaster(l_error.error, 'Unable to pull data for analytics');
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        this.l_UtilityService.lFN_HideLoader();
      }
    });
  }

  async lFN_ViewReportData(l_reportType: string) {
    this.l_UtilityService.lFN_ShowLoader();

    let l_fromDateStr = this.l_datePipe.transform(this.l_formData.fromDate, 'yyyy-MM-dd');
    let l_toDateStr = this.l_datePipe.transform(this.l_formData.toDate, 'yyyy-MM-dd');
    let l_responseReportData = null;

    if(l_reportType === 'summary') {
      l_responseReportData = this.l_analyticsService.lFN_ViewSummaryReportData(l_fromDateStr, l_toDateStr, this.l_isJsym);
    } else {
      let l_reportdata = new BookNumReceiptDTO({
        finyearmstId: this.l_formData.finyearmstId,
        txncategoryId: this.l_formData.txncategoryId
      });
      l_responseReportData = this.l_analyticsService.lFN_ViewDetailedReportData(l_reportdata);
    }
    
    l_responseReportData.subscribe({
      next: async (data) => {
        if (data.status === 200) {
          console.log('API Response ===> ', data);
          this.l_UtilityService.lFN_HideLoader();
          
          const pdfBlob = new Blob([data.body], { type: 'application/pdf' });
          console.log('PDF Blob:', pdfBlob);

          const pdfUrl = URL.createObjectURL(pdfBlob);
          console.log('PDF URL:', pdfUrl);
          
          window.open(pdfUrl, '_blank');
        } else {
          console.error('Unexpected response status:', data.status);
        }
      },
      error: (l_error) => {
        console.error('Error:', l_error);
        this.l_UtilityService.lFN_ErrorToaster(l_error.error, 'Unable to pull data for analytics');
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        this.l_UtilityService.lFN_HideLoader();
      }
    });
  }
  
  lFN_OnToggleChange(event: any) {
    this.l_isJsym = event.checked;
    console.log('this.l_isJsym == ', this.l_isJsym);
    if(this.l_isJsym === true) {
      this.l_txnTypeLabel = 'Razorpay Transactions';
    } else {
      this.l_txnTypeLabel = 'Mandal Transactions';
    }
  }

  lFN_GetCategorySelect() {
    let l_response = this.l_TallyReceiptService.lFN_GetCategory();
    l_response.subscribe({
      next: async (data) => {
        if (data.status == 200) {
          let l_categoryResponseList: Txncategory[] = [];
          console.log('success_response: ', JSON.parse(data.body));
          for await (const l_category of JSON.parse(data.body)) {
            l_categoryResponseList.push(new Txncategory(l_category));
          }
          this.l_categoryList = l_categoryResponseList;
          this.l_UtilityService.lFN_HideLoader();
        }
      },
      error: (l_error) => {
        console.error('error_response: ', l_error);
        this.l_UtilityService.lFN_ErrorToaster('Unable to fetch category list.', 'Failure');
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        console.log('Request completed');
        this.l_UtilityService.lFN_HideLoader();
      }
    });
  }

  async lFN_SetFinancialMinMaxDates() {
    const activeFinyear = JSON.parse(sessionStorage.getItem('system_params'))?.finyearmst;

    if (activeFinyear && activeFinyear.finyear) {
      const [startYearStr, endYearStr] = activeFinyear.finyear.split('-');

      const startYear = parseInt(`${startYearStr}`);
      const endYear = parseInt(`20${endYearStr}`);

      this.minDatePicker = new Date(startYear, 3, 1);
      this.maxDatePicker = new Date(endYear, 2, 31);
      console.log('minDatePicker and maxDatePicker ==> ', this.minDatePicker + ' ' + this.maxDatePicker);
    }
  }  

}
